// extracted by mini-css-extract-plugin
export var typingIndicator = "_me-0";